import type { LoadingComInstance } from '@/directive/LoadingCom.vue';
import LoadingComponent from '@/directive/LoadingCom.vue';
import { createApp } from 'vue';

// 声明模块类型扩展
declare module '#app' {
  interface NuxtApp {
    $loadingShow: () => void;
    $loadingHide: () => void;
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $loadingShow: () => void;
    $loadingHide: () => void;
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const app = createApp(LoadingComponent, { top: '40%' });
  const instance = app.mount(document.createElement('div')) as unknown as LoadingComInstance;
  const el = document.getElementById('__vooglam');
  el?.appendChild(instance.$el);

  const loadingShow = (): void => {
    instance.show();
  };

  const loadingHide = (): void => {
    instance.hide();
  };

  nuxtApp.provide('loadingShow', loadingShow);
  nuxtApp.provide('loadingHide', loadingHide);
  // TODO 下面2行有必要吗
  nuxtApp.vueApp.provide('loadingShow', loadingShow);
  nuxtApp.vueApp.provide('loadingHide', loadingHide);
});
